import type { Language, MeetingSummary } from "../types";
import { createId } from "./id";

function sentences(text: string): string[] {
  return text
    .replace(/\r/g, "")
    .split(/(?<=[。！？.!?])\s+|\n+/)
    .map((line) => line.trim())
    .filter((line) => line.length > 2);
}

export function createLocalSummary(
  transcript: string,
  language: Language,
): MeetingSummary {
  const lines = sentences(transcript);
  const decisionPattern =
    /\b(decided|agreed|approved|confirmed|decision)\b|决定|同意|批准|确认/i;
  const actionPattern =
    /\b(will|must|needs? to|action|follow[- ]?up)\b|负责|需要|跟进|完成/i;
  const riskPattern =
    /\b(risk|blocker|blocked|concern|delay)\b|风险|阻碍|延期|担忧/i;
  const ownerPattern =
    /^([A-Z][a-z]+|[\u4e00-\u9fff]{2,4})[\s,:，：]+(?:will|must|needs? to|负责|需要)/i;
  const duePattern =
    /\b(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday|tomorrow|next week|today)\b|今天|明天|下周|周[一二三四五六日天]/i;
  return {
    executiveSummary:
      lines.slice(0, 3).join(language === "zh-CN" ? " " : " ") ||
      transcript.slice(0, 300),
    decisions: lines.filter((line) => decisionPattern.test(line)).slice(0, 8),
    actionItems: lines
      .filter((line) => actionPattern.test(line))
      .slice(0, 12)
      .map((task) => ({
        id: createId(),
        task,
        owner: task.match(ownerPattern)?.[1] ?? "",
        dueDate: task.match(duePattern)?.[0] ?? null,
        done: false,
      })),
    risks: lines.filter((line) => riskPattern.test(line)).slice(0, 8),
  };
}
